import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import PropTypes from 'prop-types';
import DialogPanel from '../dialog-panel/dialog-panel';
import DialogPanelBody from '../dialog-panel/dialog-panel-body/dialog-panel-body';
import BesicTable from '../table/basicTable';
// import Pagination from '../pagination/pagination';
import './preview-excelfile.scss';
import DialogPanelFooter from '../dialog-panel/dialog-panel-footer/dialog-panel-footer';
import Button from '../button/button';

export default function PreviewExcelFile({ file, setExcelData }) {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [t] = useTranslation('manageorders');

  const getExcelColumn = (index) => {
    let column = '';
    let colIndex = index;

    while (colIndex >= 0) {
      column = String.fromCharCode((colIndex % 26) + 65) + column;
      colIndex = Math.floor(colIndex / 26) - 1;
    }

    return column;
  };

  useEffect(() => {
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const binary = new Uint8Array(event.target.result);
        const workbook = XLSX.read(binary, { type: 'array' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

        if (jsonData.length > 0) {
          const keys = Object.keys(jsonData[0]);

          const dynamicColumns = [
            {
              Header: '',
              accessor: 'rowNumber',
              align: 'center',
              Cell: ({ row }) => row.index + 1,
            },
            ...keys.map((key, index) => ({
              Header: getExcelColumn(index),
              accessor: key,
              align: 'center',
            })),
          ];

          const headerRow = {};
          keys.forEach((key) => {
            headerRow[key] = key;
          });

          const tableData = [
            { rowNumber: 1, ...headerRow },
            ...jsonData.map((row, index) => ({
              rowNumber: index + 2,
              ...row,
            })),
          ];

          setColumns(dynamicColumns);
          setData(tableData);
        }
      } catch (error) {
        console.error('Excel preview error:', error);
      }
    };

    reader.readAsArrayBuffer(file);
  }, [file]);

  return (
    <DialogPanel
      title={t('manageordersscreen.productdetails.previewExeldialog.title')}
      titleClassName="preview-title"
    >
      <DialogPanelBody>
        <div className="preview-excel-wrapper">
          <BesicTable
            columns={columns}
            data={data}
            pageSize={10}
            className="auto-column-width"
            noSpacing
          />
        </div>

        {/*    <div className="preview-pagination">
          <Pagination />
        </div>
 */}
        {/* <div className="preview-summary">
          <p className="summary-title">Summary</p>

          <p className="summary-details">
            Total Rows : <span>{data.length - 1}</span> & Columns :{' '}
            <span className="mr-12">{columns.length - 1}</span> |{' '}
            <span className="ml-12">Total Errors : 0</span>
          </p>
        </div> */}
      </DialogPanelBody>
      <DialogPanelFooter>
        <Button
          color="cancel"
          label={t(
            'manageordersscreen.productdetails.previewExeldialog.cancel'
          )}
          styles="cancel"
        />

        <Button
          color="submit"
          label={t(
            'manageordersscreen.productdetails.previewExeldialog.importdata'
          )}
          styles="submit"
          onClick={() => {
            setExcelData(data);
          }}
        />
      </DialogPanelFooter>
    </DialogPanel>
  );
}

PreviewExcelFile.propTypes = {
  file: PropTypes.instanceOf(File),
  setExcelData: PropTypes.func,
};

PreviewExcelFile.defaultProps = {
  file: null,
  setExcelData: () => {},
};
